import React from "react";

const FALLBACK =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 4'><rect width='3' height='4' fill='%23F5F2EB'/></svg>";

export default function SafeImage({ src, alt = "", className = "", ...rest }) {
  const [errored, setErrored] = React.useState(false);
  const resolved = !src || errored ? FALLBACK : src;
  return (
    <img
      src={resolved}
      alt={alt}
      onError={() => setErrored(true)}
      className={className}
      {...rest}
    />
  );
}
